<template>
  <div>
    <v-row class="d-flex justify-start">
      <v-alert
        class="ml-3 d-flex justify-center"       
        border="left"
        color="#529dfe"
        elevation="2"
        style="position:absolute; z-index:1;"
        width="90%"
        height="70"
      >
      <v-row align="center">
        <v-col class="grow" >
            <h4 class="font-weight-bold white--text">
                <small>{{ partyname }}</small>
            </h4>
        </v-col>
        <!-- <v-col class="shrink" >-->
          <v-btn class="" fab dark small color="primary" @click="showItems" >
             <v-icon dark>
             mdi-eye
            </v-icon>          
          </v-btn>
        <!-- </v-col>  -->
      </v-row>     
      </v-alert>
      <v-card
        class="mx-auto mt-9 pa-3"
        color="#546E7A"
        dark
        width="100% "
        height="175"
        elevation="3"
      >
        <v-row class="d-flex justify-center" dense>
          <v-col cols="3">
            <div>
              <div
                class="caption white--text font-weight-light mt-5 d-flex justify-center"
              > Date
              </div>
              <h3
                class="subtitle-1 font-weight-bold white--text d-flex justify-center"
              ><small>{{ formatdate(date) }}</small>
              </h3>
            </div>
          </v-col>
          <v-col cols="3">
            <div>
              <div
                class="caption white--text font-weight-light mt-5 d-flex justify-center"
              > SO#
              </div>
              <h3
                class="subtitle-1 font-weight-bold white--text d-flex justify-center"
              ><small>{{so_no}}</small>               
              </h3>
            </div>
          </v-col>
          <v-col cols="3">
            <div>
              <div
                class="caption white--text font-weight-light mt-5 d-flex justify-center"
              > Party Code
              </div>
              <h3
                class="subtitle-1 font-weight-bold white--text d-flex justify-center"
              ><small>{{ partycode }}</small>
              </h3>
            </div>
          </v-col>
          
           <v-col cols="3">
            <div>
              <div
                class="caption white--text font-weight-light mt-5 d-flex justify-center"
              > EDD
              </div>
              <h3
                class="subtitle-1 font-weight-bold white--text d-flex justify-center"
              ><small>{{ formatdate(EDD) }}</small>
              </h3>
            </div>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center" dense>
          <v-col cols="4">
            <div>
              <div
                class="caption white--text font-weight-light mt-5 d-flex justify-center"
              > Created by
              </div>
              <h3
                class="subtitle-1 font-weight-bold white--text d-flex justify-center"
              > <small>{{ createdby }}</small>
              </h3>
            </div>
          </v-col>
          <v-col cols="4">
            <div>
              <div
                class="caption white--text font-weight-light mt-5 d-flex justify-center"
              > Net Amt (AED)
              </div>
              <h3
                class="subtitle-1 font-weight-bold white--text d-flex justify-center"
              > <small>{{ netamt }}</small>
              </h3>
            </div>
          </v-col>
          <v-col cols="4">
            <div>
              <div
                class="caption white--text font-weight-light mt-5 d-flex justify-center"
              > Status
              </div>
              <h3
                class="subtitle-1 font-weight-bold white--text d-flex justify-center"
              > <small>{{ status }}</small>
              </h3>
            </div>
          </v-col>
        </v-row>
      </v-card>
      <v-progress-linear
        indeterminate
        color="primary"
        v-show="loading"
      ></v-progress-linear>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Ordercard",
  components: {},
  props: [
    "so_no",
    "date",
    "partycode",
    "partyname",
    "netamt",
    "createdby",
    "status",
    "salsubledger_docno",
    "EDD"

  ],
  data() {
    return {      
    };
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    isAdmin(){
      if(this.$store.getters.fbuserdata.usertype == 1)
       return true;
      else
       return false;
    },
    editETD(){
      if(this.$store.getters.fbuserdata.edit_premisions.includes("etd") || this.isAdmin)
        return true;
      else
        return false;
    }
  },
  methods: {
    formatdate(date){      
    return(moment(date).format('DD-MM-YYYY'))
    },
    showItems() {
      this.$emit("showOrderItems");
    },    
  },
};
</script>
